
export const toBase64Payload = async (filesByField) => {
  const payload = [];

  for (const [fieldKey, files] of Object.entries(filesByField)) {
    for (const file of files) {
      const raw = file.originFileObj;
      if (!raw) continue;

      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const result = reader.result;
          resolve(result.includes(',') ? result.split(',')[1] : result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(raw);
      });

      payload.push({ fieldKey, base64 });
    }
  }

  return payload;
};
